<template>
  <div class="box text-center">
    <div v-if="getRoleType === 99" class="box-body">
      <ul class="nav nav-tabs" style="margin-bottom: 10px;">
        <li role="presentation" :class="{'active': tab == 1}" @click="changeTab(1)">
          <a>基本資訊</a>
        </li>
        <!--抽成對帳權限開開關-->
        <li v-if="hasCommissionPermission" role="presentation" :class="{'active': tab == 2}" @click="changeTab(2)">
          <a>作廢訂單額度</a>
        </li>
      </ul>
    </div>
    <div v-show="tab === 1" class="box-body form">
      <div class="del-block" v-if="$route.name === 'upBrand' && getRoleType === 99">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">刪除品牌</div>
      </div>
      <br/>
      <br />
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            代碼
          </span>
          <input
            class="form-control"
            placeholder="小英數組合"
            type="text"
            v-model="brandInfo.brand_code"
            @keyup="verityCode()"
            id="brand-code"
            minlength="6"
            maxlength="30"
          />
        </div>
        <br>
      </div>
      <div v-if="!info && getRoleType === 99">
        <div class="input-group">
        <span class="input-group-addon">
           鍵值(專屬用brand_key)
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.brand_key" @keyup="verityKey()" id="brand-key" minlength="1" maxlength="10">
        </div>
      </div>
      <div v-if="!info && getRoleType === 99" class="text-right text-15 text-red">(數字組合)<br /><br /></div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            名稱
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="brandInfo.name"
            maxlength="30"
          />
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊</span>
            縮寫名稱
          </span>
          <input
            class="form-control"
            placeholder=""
            type="text"
            v-model="brandInfo.name_short"
            maxlength="30"
          >
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            品牌別名
          </span>
          <div>
            <multiselect
              v-model="brandInfo.name_alias"
              :options="nameAliasList"
              @tag="addAliasTag"
              tag-placeholder="新增品牌別名"
              placeholder="新增品牌別名"
              label="label"
              track-by="value"
              :multiple="true"
              :taggable="true"
            />
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
        <span class="input-group-addon">
          標語
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.slogan" maxlength="45">
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
        <span class="input-group-addon">
          訊息
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.comment" maxlength="20">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          描述
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.description" maxlength="100">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          品牌頁介紹
        </span>
          <textarea class="w-100-p form-control" name="introduction" v-model="brandInfo.introduction" cols="30" rows="10" maxlength="65535"></textarea>
          <!-- <input class="form-control" placeholder="" type="text" v-model="brandInfo.introduction" maxlength="100"> -->
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          Youtube影片代碼
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.youtube_video_code" maxlength="50">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          電子信箱
        </span>
          <input class="form-control" placeholder="" type="text" v-model="brandInfo.email" maxlength="50">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          品牌資訊
        </span>
          <multiselect v-model="select.websiteSetting" tag-placeholder="前端顯示的品牌資訊"
                       placeholder="選擇類型" label="label" track-by="value" :options="typeOptions"
                       :multiple="true" :allow-empty="true"></multiselect>
        </div>
        <div class="form-control" v-if="select.websiteSetting.length">
          <div class="input-group m-y-10" v-for="website in select.websiteSetting">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>{{website.label}}
            </span>
            <input class="form-control" placeholder="網站連結" type="text" v-model="website.url" maxlength="1000">
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>前端顯示
        </span>
          <div class="form-group">
            <select class="form-control" v-model="brandInfo.is_visible">
              <option value="1">顯示</option>
              <option value="0">不顯示</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30">
        <div class="input-group">
          <span class="input-group-addon">
            LOGO
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!brandInfo.image_name" class="text-black" v-text="'沒有圖片'" />
              <img :src="brandInfo.image_name" class="h-auto img-responsive" v-if="brandInfo.image_name" data-toggle="modal">
            </span>
          </div>
          <div class="form-control h-100">
            <label class="btn-upload btn btn-default" style="margin-top: 25px;" for="brand-img-load">
              選擇圖片
            </label>
            <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
          </div>
        </div>
        <!--<div class="input-group">-->
        <!--<span class="input-group-addon">-->
          <!--圖片-->
        <!--</span>-->
        <!--</div>-->
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30" class="text-right text-15 text-red">(圖片大小為200x200)<br /></div>
      <div v-if="getRoleType === 99 || getRoleType === 30">
        <div class="input-group">
          <span class="input-group-addon">
            聯名圖
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!brandInfo.logo_name" class="text-black" v-text="'沒有圖片'" />
              <div v-if="brandInfo.logo_name"  class="h-auto img-responsive">
                <object type="image/svg+xml" style="height: 90px" class="svg-img" :data="brandInfo.logo_name"></object>
              </div>
            </span>
          </div>
          <div class="form-control h-100">
            <label class="btn-upload btn btn-default" style="margin-top: 25px;" for="brand-logo-load">
              選擇圖片
            </label>
            <input class="form-control" type="file" style="display: none;" @change="onLogoFileChange" id="brand-logo-load">
          </div>
        </div>
      </div>
      <div v-if="getRoleType === 99 || getRoleType === 30 " class="text-right text-15 text-red">(圖片大小為300x90)<br /></div>
      <div v-if="getRoleType === 99 || getRoleType === 30">
        <div class="input-group">
          <span class="input-group-addon">
            底圖照片
          </span>
          <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!brandInfo.photo_name" class="text-black" v-text="'沒有圖片'" />
              <img :src="brandInfo.photo_name" class="h-auto img-responsive" v-if="brandInfo.photo_name" data-toggle="modal">
            </span>
          </div>
          <div class="form-control h-100">
            <label class="btn-upload btn btn-default" style="margin-top: 25px;" for="brand-photo-load">
              選擇圖片
            </label>
            <input class="form-control" type="file" style="display: none;" @change="onPhotoFileChange" id="brand-photo-load">
          </div>
        </div>
        <div v-if="getRoleType === 99 || getRoleType === 30 " class="text-right text-15 text-red">(圖片大小為800x460)</div>
        <div class="photo-setup text-left" v-if="$route.name !== 'crBrand'">
          <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>套用指定門市
            </span>
            <div class="form-control">
              <div class="radio inline-block cell-right">
                <label>
                  <input v-model="isCopyStore" type="radio" name="setStore" :value="true"/>
                  是
                </label>
                <label class="ml-5">
                  <input v-model="isCopyStore" type="radio" name="setStore" :value="false"/>
                  否
                </label>
              </div>
            </div>
          </div>
          <muti-select-two v-if="isCopyStore" :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
        </div>
      </div>
      <div v-if="getRoleType === 99" class="m-t-20">
        <div class="input-group">
          <span class="input-group-addon">
            餐點種類
          </span>
          <div>
            <multiselect
              v-model="brandInfo.binding_meal_tag_ids"
              tag-placeholder="餐點種類"
              placeholder="餐點種類"
              label="label"
              track-by="value"
              :options="mealTagList"
              :multiple="true"
            />
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            品牌主色
          </span>
          <div class="form-group m-b-5 text-left">
            <div class="radio inline-block">
              <label>
                <input v-model="brandInfo.clear_main_color_code" name="clearMainColor" type="radio" :value="1"/>
                預設(你訂)
              </label>
              <label class="m-l-10">
                <input class="m-t-4" v-model="brandInfo.clear_main_color_code" name="clearMainColor" type="radio" :value="0"/>
                自訂顏色
                <input class="m-l-10" type="color" v-model="brandInfo.main_color_code">
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div v-if="getRoleType === 99">
        <div class="input-group">
          <span class="input-group-addon">
            品牌副色
          </span>
          <div class="form-group m-b-5 text-left">
            <div class="radio inline-block">
              <label>
                <input v-model="brandInfo.clear_sub_color_code" name="clearSubColor" type="radio" :value="1"/>
                預設(你訂)
              </label>
              <label class="m-l-10">
                <input class="m-t-4" v-model="brandInfo.clear_sub_color_code" name="clearSubColor" type="radio" :value="0"/>
                自訂顏色
                <input class="m-l-10" type="color" v-model="brandInfo.sub_color_code">
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
      <!-- /.box-body -->
    </div>

    <div v-show="tab === 2 && getRoleType === 99" class="box-body form text-left">
      <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊</span>
          <span>額度計算</span>
        </span>

        <div class="flex align-center h-34">
          <div class="radio inline-block">
            <label>
              <input type="radio" name="independent" :value="1" v-model="orderCommissionSetting.quota_type" />
              品牌總額度
              <span
                class="m-l-5"
                data-toggle="tooltip"
                data-placement="bottom"
                title="此為整個品牌的作廢訂單總額度，非單一門市。"
              >
                <i class="fa fa-question-circle" aria-hidden="true" />
              </span>
            </label>
          </div>
          <div class="radio inline-block">
            <label>
              <input type="radio" name="independent" :value="2" v-model="orderCommissionSetting.quota_type" />
              每間門市額度
              <span
                class="m-l-5"
                data-toggle="tooltip"
                data-placement="bottom"
                title="每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。"
              >
                <i class="fa fa-question-circle" aria-hidden="true" />
              </span>
            </label>
          </div>
        </div>
      </div>
      <br>

      <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>每月作廢訂單額度 (筆)
        </span>
        <input
          v-model.number="brandInfo.order_commission_setting.allow_invalid_order_quota"
          class="form-control"
          type="number"
          maxlength="10"
        />
      </div>
      <br>

      <div v-if="info">
        <h3 class="text-center">獨立產出抽成對帳表門市</h3>
        <h5><span class="text-red">＊</span> 如需調整請至編輯門市-計費方式設定</h5>
        <div class="row">
          <div class="col-sm-12 table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
                <tr role="row">
                  <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">#</th>
                  <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">門市名稱</th>
                  <th class="vertical-m" colspan="1" rowspan="1" aria-controls="example1" tabindex="0">額度</th>
                </tr>
              </thead>
              <tbody v-if="isLoading">
                <tr>
                  <td colspan="3" class="text-center">資料讀取中......</td>
                </tr>
              </tbody>
              <tbody v-else-if="independentStoreList.length === 0">
                <tr style="background-color: white">
                  <td rowspan="1" colspan="3" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                    <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                    <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(row, index) in independentStoreList" :key="index" class="even" role="row">
                  <td class="sorting_1">{{ index + 1 }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.allow_invalid_order_quota }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <paginate
            :pageAmount="pageAmount"
            :total="total"
            :isActive="isActive"
            :groupAmount="groupAmount"
            :clickPage="clickPage"
          />
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <!-- Left Button -->
      <button v-if="!info && tab !== 1" class="btn btn-default" @click="tab--">
        上一步
      </button>
      <button v-else class="btn btn-default" @click="$router.go(-1)">
        取消
      </button>
      <!-- Right Button -->
      <button v-if="!info && tab !== tabTotal" class="btn btn-success" @click="tab++">
        下一步
      </button>
      <button v-if="!info && tab === tabTotal" class="btn btn-success" @click="checkInputEmpty('cr')">
        新增
      </button>
      <button v-if="info" class="btn btn-success" @click="checkInputEmpty('up')">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import matcherModal from '../../../elements/Modal.vue'
import $ from 'jquery'
import { mapGetters } from 'vuex'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      brandName: '',
      brandType: '',
      tab: 1,
      tabTotal: 2, // Tab 總數 (注意：新增 Tab 必須修改此數值)
      image: '',
      img: {
        width: 0,
        height: 0
      },
      mealTagList: [],
      brandInfo: {
        binding_meal_tag_ids: [],
        brand_code: '',
        brand_key: '',
        name: '',
        name_short: '',
        slogan: '',
        comment: '',
        description: '',
        is_visible: 1,
        image_name: '',
        logo_name: '',
        email: '',
        youtube_video_code: '',
        introduction: '',
        order_commission_setting: {
          allow_invalid_order_quota: 0
        },
        main_color_code: '#000000',
        sub_color_code: '#000000',
        clear_main_color_code: 1, // 使用你訂色
        clear_sub_color_code: 1, // 使用你訂色
        name_alias: [] // 品牌別名
      },
      delOption: {
        id: 'delModal',
        title: '刪除品牌',
        body: '刪除某一品牌，此處刪除只會標註刪除，不會真的在資料庫移除。另外，此品牌無店家才可刪除！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBrand'
          }
        ]
      },
      typeOptions: [
        { label: '官網', value: 1, url: '' },
        { label: 'Facebook', value: 2, url: '' },
        { label: 'Instagram', value: 3, url: '' },
        { label: 'Line', value: 4, url: '' }
      ],
      select: {
        websiteSetting: []
      },
      reNew: 0,
      reSet: 0,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      isCopyStore: true,
      // 作廢訂單額度
      independentStoreList: [],
      isLoading: false,
      total: 0,
      count: 10,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      allowRestric: false, // 抽成對帳權限開開關
      nameAliasList: [
        { label: '無指定',
          value: ''
        }
      ]
    }
  },
  watch: {
    '$route.query.tab' (val) {
      if (!val) return
      this.tab = val
    }
  },
  methods: {
    clickPage (index) {
      this.tableIndex = index
      this.getList()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    trigger (event) {
      if (event === 'delBrand') {
        this.delBrand()
      }
    },
    delBrand () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push('/brandTable')
        }
      })
    },
    init () {
      const self = this
      if (typeof this.info !== 'undefined') {
        if (this.getRoleType === 99) {
          this.getMealTagList(function () {
            self.getBrandInfo()
          })
        } else this.getBrandInfo()
      } else this.getMealTagList(function () {})
      if (this.$route.name !== 'crBrand') {
        this.getStoreBrief()
      }
    },
    getStoreBrief () {
      this.storeBrief = []
      this.addStoresSetting.options = []
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            if (parseInt(sList[i].store_id, 10) !== parseInt(self.$route.params.store_id, 10)) {
              self.storeBrief.push(obj)
              self.addStoresSetting.options.push(obj)
            }
          }
          self.reNew++
        }
      })
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 1) // LOGO
      }
    },
    onPhotoFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 3) // 底圖照片
      }
    },
    onLogoFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png|svg)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 2) // 聯名圖
      }
    },
    createImage (file, method) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (method === 1) self.brandInfo.image_name = img.src
        else if (method === 2) self.brandInfo.logo_name = img.src
        else if (method === 3) self.brandInfo.photo_name = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize(null, method)
        }
      }
      reader.readAsDataURL(file, method)
    },
    checkImgSize (type, method) {
      var self = this
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 300 || this.img.height !== 90) && this.img.width !== 0 && this.img.height !== 0 && method === 2) {
        this.$notify({
          title: '提醒',
          text: '聯名尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳300x90之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        if (this.getRoleType === 99 || this.getRoleType === 30) {
          this.createdBrand()
        }
      } else if (type === 'up') {
        if (this.getRoleType === 99 || this.getRoleType === 30) {
          if ($('#brand-logo-load')[0].files[0]) this.updatedLogo('up')
          else if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
          else if ($('#brand-photo-load')[0].files[0] || (this.addStoresSetting.choose.length > 0 && this.isCopyStore)) this.updatedPhoto()
          else this.updatedBrand()
        }
      }
    },
    verityCode () {
      var e = $('#brand-code')
      this.brandInfo.brand_code = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[a-z0-9]*/))
      }
    },
    verityKey () {
      var e = $('#brand-key')
      this.brandInfo.brand_key = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    checkInputEmpty (type) {
      let title = ''
      let text = ''
      if (type === 'cr' || this.tab === 1) {
        if (!this.getInput.brand_code && this.getRoleType === 99) {
          title = '請填寫代碼'
          text = '代碼為英文小寫與數字的組合！'
        } else if (this.getInput.brand_code.length < 6 && this.getRoleType === 99) {
          title = '提醒'
          text = '代碼須為6~12字，英文小寫與數字的組合！'
        } else if (!this.getInput.name && this.getRoleType === 99) {
          title = '提醒'
          text = '請填寫名稱！'
        } else if (!this.getInput.name_short && this.getRoleType === 99) {
          title = '提醒'
          text = '請填寫縮寫名稱！'
        } else if (this.getInput.email && this.isEmailFalse(this.getInput.email)) {
          title = '提醒'
          text = '請填寫正確的電子信箱！'
        } else if (this.select.websiteSetting.length && this.websiteFalse()) {
          title = '提醒'
          text = '請填寫正確的品牌資訊！'
        }
      } else if (type === 'cr' || this.tab === 2) {
        if (this.getRoleType === 99 && this.brandInfo.order_commission_setting.allow_invalid_order_quota === '') {
          title = '提醒'
          text = '請填寫每月作廢訂單額度！'
        }
      }
      if (title && text) {
        this.$notify({
          title: title,
          text: text,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (![30, 99].includes(this.getRoleType) || (type === 'up' && this.tab === 2)) {
          // 非 Admin 或品牌權限 或 編輯計費方式設定 才不用檢查圖片
          this.updatedBrand()
        } else {
          this.checkImgSize(type)
        }
      }
    },
    changeTab (index) {
      this.tab = index
      const query = Object.assign({}, this.$route.query)
      this.$router.replace({ query: {
        ...query,
        tab: index
      }})
    },
    websiteFalse () {
      var wList = this.select.websiteSetting
      var parseUrl = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/
      for (var i = 0; i < wList.length; i++) {
        if (!wList[i].url) return true
        else if (wList[i].url) {
          if (wList[i].url.search(parseUrl) === -1) {
            return true
          }
        }
      }
      return false
    },
    isEmailFalse (email) {
      var emailRule = /^[^\s]+@[^\s]+\.[^\s]{2,}$/
      if (email) {
        if (email.search(emailRule) !== -1) return false
        else return true
      }
      return false
    },
    createdBrand () {
      var self = this
      var data = new FormData()
      data.append('brand_code', this.getInput.brand_code)
      data.append('name', this.getInput.name)
      data.append('is_visible', this.brandInfo.is_visible)
      data.append('order_commission_setting', JSON.stringify(this.brandInfo.order_commission_setting)) // 每月可作廢的訂單額度
      const ids = this.brandInfo.binding_meal_tag_ids.map(item => item.value)

      // 品牌主色 & 副色
      data.append('clear_main_color_code', this.brandInfo.clear_main_color_code)
      data.append('clear_sub_color_code', this.brandInfo.clear_sub_color_code)
      if (!this.brandInfo.clear_main_color_code) data.append('main_color_code', this.brandInfo.main_color_code.replace('#', ''))
      if (!this.brandInfo.clear_sub_color_code) data.append('sub_color_code', this.brandInfo.sub_color_code.replace('#', ''))

      if (this.brandInfo.binding_meal_tag_ids.length) data.append('binding_meal_tag_ids', JSON.stringify(ids))
      if (this.getInput.brand_key) data.append('brand_key', this.getInput.brand_key)
      if (this.getInput.name_short) data.append('name_short', this.getInput.name_short)
      if (this.getInput.slogan) data.append('slogan', this.getInput.slogan)
      if (this.getInput.comment) data.append('comment', this.getInput.comment)
      if (this.getInput.description) data.append('description', this.getInput.description)
      if (this.getInput.email) data.append('email', this.getInput.email)
      if (this.getInput.youtube_video_code) data.append('youtube_video_code', this.getInput.youtube_video_code)
      if (this.getInput.introduction) data.append('introduction', this.getInput.introduction)
      // 將品牌別名數組轉換為逗號分隔的字符串
      if (this.brandInfo.name_alias && Array.isArray(this.brandInfo.name_alias) && this.brandInfo.name_alias.length > 0) {
        const aliasStr = this.brandInfo.name_alias.map(item => item.value).join(',')
        data.append('name_alias', aliasStr)
      }
      if (this.select.websiteSetting.length) {
        var settingList = []
        this.select.websiteSetting.forEach(function (setting) {
          var obj = {type: setting.value, url: setting.url}
          settingList.push(obj)
        })
        data.append('website_setting', JSON.stringify(settingList))
      }
      if ($('#brand-img-load')[0].files[0]) data.append('image_file', $('#brand-img-load')[0].files[0])
      if ($('#brand-logo-load')[0].files[0]) data.append('logo_file', $('#brand-logo-load')[0].files[0])
      if ($('#brand-photo-load')[0].files[0]) data.append('photo_file', $('#brand-photo-load')[0].files[0])
      var url = '/brand/'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            // self.$router.push({path: '/brandTable'})
            self.$router.go(-1)
          }
        })
      }
    },
    updatedLogo (method) {
      var self = this
      var data = new FormData()
      data.append('image_file', $('#brand-logo-load')[0].files[0])
      var url = '/brand/' + this.$route.params.brand_id + '/logo'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (method === 'cr') self.createdBrand()
          else if (method === 'up') {
            if ($('#brand-img-load')[0].files[0]) self.updatedIcon()
            else if ($('#brand-photo-load')[0].files[0]) this.updatedPhoto()
            else if (self.getRoleType === 99) self.updatedBrand()
            else {
              self.$notify({
                title: response.data.message,
                text: response.data.description,
                duration: 3000,
                type: 'success',
                width: 400
              })
              // self.$router.push({path: '/brandTable'})
              self.$router.go(-1)
            }
          }
        }
      })
    },
    updatedIcon () {
      var self = this
      var data = new FormData()
      data.append('image_file', $('#brand-img-load')[0].files[0])
      var url = '/brand/' + this.$route.params.brand_id + '/icon'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if ($('#brand-photo-load')[0].files[0]) self.updatedPhoto()
          else if (self.getRoleType === 99 || self.getRoleType === 30) self.updatedBrand()
          else {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            // self.$router.push({path: '/brandTable'})
            self.$router.go(-1)
          }
        }
      })
    },
    updatedPhoto () {
      var self = this
      var data = new FormData()
      if ($('#brand-photo-load')[0].files[0]) {
        data.append('image_file', $('#brand-photo-load')[0].files[0])
      }
      if (this.addStoresSetting.choose.length > 0) {
        data.append('store_list', this.addStoresSetting.choose.toString())
      }
      var url = '/brand/' + this.$route.params.brand_id + '/photo'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (self.getRoleType === 99 || self.getRoleType === 30) self.updatedBrand()
          else {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            // self.$router.push({path: '/brandTable'})
            self.$router.go(-1)
          }
        }
      })
    },
    updatedBrand () {
      var self = this
      let data = {}
      if (this.tab === 1) {
        const ids = this.brandInfo.binding_meal_tag_ids.map(item => item.value)
        data = {
          brand_key: this.getInput.brand_key,
          brand_code: this.getInput.brand_code,
          name: this.getInput.name,
          is_visible: this.brandInfo.is_visible,
          name_short: this.getInput.name_short,
          slogan: this.getInput.slogan,
          comment: this.getInput.comment,
          description: this.getInput.description,
          youtube_video_code: this.getInput.youtube_video_code,
          introduction: this.getInput.introduction,
          binding_meal_tag_ids: ids
        }
        // 將品牌別名數組轉換為逗號分隔的字符串
        if (this.brandInfo.name_alias && Array.isArray(this.brandInfo.name_alias) && this.brandInfo.name_alias.length > 0) {
          data['name_alias'] = this.brandInfo.name_alias.map(item => item.value).join(',')
        } else {
          data['name_alias'] = ''
        }
        if (this.getInput.email) data['email'] = this.getInput.email
        // 品牌主色 & 副色
        if (!this.brandInfo.clear_main_color_code) data['main_color_code'] = this.brandInfo.main_color_code.replace('#', '')
        if (!this.brandInfo.clear_sub_color_code) data['sub_color_code'] = this.brandInfo.sub_color_code.replace('#', '')
        data['clear_main_color_code'] = this.brandInfo.clear_main_color_code
        data['clear_sub_color_code'] = this.brandInfo.clear_sub_color_code
        // 品牌官網資訊
        var settingList = []
        this.select.websiteSetting.forEach(function (setting) {
          var obj = {type: setting.value, url: setting.url}
          settingList.push(obj)
        })
        data['website_setting'] = settingList
      } else if (this.tab === 2) {
        data['order_commission_setting'] = JSON.stringify(this.brandInfo.order_commission_setting)
      }
      var url = '/brand/' + this.$route.params.brand_id
      if (data) {
        this.getDataH('put', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
          }
        })
      }
    },
    getMealTagList (callback) {
      var self = this
      var url = '/mealTag/listBrief?is_visible=1'
      self.mealTagList = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            const obj = {
              label: tag.name,
              value: tag.tag_id
            }
            self.mealTagList.push(obj)
          })
          callback()
        }
      })
    },
    getBrandInfo () {
      var url = '/brand/' + this.$route.params.brand_id
      this.select.websiteSetting = []
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.brandInfo = response.data.brand_info
          this.$set(this.brandInfo, 'binding_meal_tag_ids', [])
          if (this.brandInfo.meal_tag_setting) {
            this.brandInfo.meal_tag_setting.forEach((setting) => {
              var obj = {value: setting.tag_id, label: setting.name}
              const hasTag = this.mealTagList.find((mealTag) => { return mealTag.value === setting.tag_id })
              if (hasTag) {
                this.brandInfo.binding_meal_tag_ids.push(obj)
              }
            })
          }
          this.brandInfo.website_setting.forEach((setting) => {
            var obj = {value: setting.type, url: setting.url, label: ''}
            obj.label = this.typeOptions.find((typeO) => { return setting.type === typeO.value }).label
            this.select.websiteSetting.push(obj)
          })
          if (this.brandInfo.photo_store_list && this.brandInfo.photo_store_list.length > 0) {
            this.addStoresSetting.choose = this.brandInfo.photo_store_list.map(x => x.store_id)
          }
          // 取得品牌主色 & 副色
          const mainColor = this.brandInfo.main_color_code
          const subColor = this.brandInfo.sub_color_code
          if (mainColor) {
            this.brandInfo.main_color_code = '#' + mainColor
            this.brandInfo.clear_main_color_code = 0
          } else {
            this.brandInfo.clear_main_color_code = 1
          }
          if (subColor) {
            this.brandInfo.sub_color_code = '#' + subColor
            this.brandInfo.clear_sub_color_code = 0
          } else {
            this.brandInfo.clear_sub_color_code = 1
          }
          // 處理品牌別名：將後端的數組轉換為對象數組
          if (this.brandInfo.name_alias && Array.isArray(this.brandInfo.name_alias)) {
            this.brandInfo.name_alias = this.brandInfo.name_alias.map(alias => {
              // 如果已經是對象格式，直接使用；否則轉換
              if (typeof alias === 'string') {
                return { label: alias, value: alias }
              }
              return alias
            })
            // 同時更新選項列表
            this.brandInfo.name_alias.forEach(aliasObj => {
              const exists = this.nameAliasList.some(item => item.value === aliasObj.value)
              if (!exists) {
                this.nameAliasList.push(aliasObj)
              }
            })
          } else if (!this.brandInfo.name_alias) {
            this.brandInfo.name_alias = []
          }
        }
      })
    },
    getStoreQuota () {
      // 取得品牌下各門市的作廢訂單額度
      const url = '/brand/' + this.$route.params.brand_id + '/independentStoreList?page=' + this.tableIndex + '&size=' + this.count
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.independentStoreList = response.data.list
        }
      })
    },
    addAliasTag (newTag) {
      const tag = {
        label: newTag,
        value: newTag
      }
      const existsInList = this.nameAliasList.some(item => item.value === newTag)
      if (!existsInList) {
        this.nameAliasList.push(tag)
      }
      this.brandInfo.name_alias.push(tag)
    }
  },
  created () {
    this.init()
    if (!this.info && !this.hasCommissionPermission) {
      this.tabTotal = 1
    }
    if (this.getRoleType === 99 && this.info) {
      this.getStoreQuota()
      if (this.$route.query.tab) {
        this.tab = parseInt(this.$route.query.tab, 10)
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getRestricted']),
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getInput () {
      var bInfo = this.brandInfo
      return {
        brand_key: this.checkInput(bInfo.brand_key),
        brand_code: this.checkInput(bInfo.brand_code),
        name: this.checkInput(bInfo.name),
        name_short: this.checkInput(bInfo.name_short),
        slogan: this.checkInput(bInfo.slogan),
        comment: this.checkInput(bInfo.comment),
        description: this.checkInput(bInfo.description),
        email: this.checkInput(bInfo.email),
        youtube_video_code: this.checkInput(bInfo.youtube_video_code),
        introduction: this.checkInput(bInfo.introduction)
      }
    },
    hasCommissionPermission () {
      // 擁有抽成對帳系統功能權限
      return this.getRestricted.includes(900)
    },
    orderCommissionSetting: {
      get () {
        const def = {
          quota_type: 0, // 額度計算類型 | 1: 品牌總額度, 2: 每間門市額度
          allow_invalid_order_quota: 0, // 每月可作廢的品牌總額度
          store_allow_invalid_order_quota: 0, // 每月可作廢的每間門市額度
          default_allow_invalid_order_quota: 0, // 使用目前的門市數與設定試算出的每月實際可作廢的品牌總額度
          default_store_allow_invalid_order_quota: 0 // 預設的每月實際可作廢的每間門市額度
        }
        return this.brandInfo.order_commission_setting || def
      },
      set (val) {
        console.log('orderCommissionSetting', val)
        this.brandInfo.order_commission_setting = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-t-4 {
  margin-top: 4px;
}
.photo-setup {
  padding: 0px 10px 10px 16px;
  border: 1px solid #E1E1E1;
  border-top: none;
  display: inline-block;
}
.radio + .radio {
  margin-top: initial;
}
</style>



// WEBPACK FOOTER //
// BrandFormTemp.vue?5c08b353